/* eslint-disable react/button-has-type */
import React, { Suspense, useState } from 'react';

import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import CommonAlert from 'components/CommonAlert/CommonAlert';
import ProductTransference from 'components/Dialogs/ProductTransference';
import WriteOffReleases from 'components/Dialogs/WriteOffReleases';
import * as UserActions from 'store/actions/user';
import ProductionSecondaryIcon from 'images/icons/menu-items/productionSecondaryIcon';
import CountSecondaryIcon from 'images/icons/menu-items/countSecondaryIcon';
import ReceivementSecondaryIcon from 'images/icons/menu-items/receivementSecondaryIcon';
import TrashSecondaryIcon from 'images/icons/signals/removesAndDeletes/trashSecondaryIcon';
import TransferSecondaryIcon from 'images/icons/menu-items/transferSecondaryIcon';

function FooterButton({ icon, label, onClick, className, styleImg }) {
  const isString = typeof icon === 'string';

  return (
    <button className="footer-button" onClick={onClick}>
      <div className="footer-img">
        {isString ? (
          <img src={icon} alt={`${label}Alt`} className={styleImg} />
        ) : React.isValidElement(icon) ? (
          React.cloneElement(icon, {
            className: styleImg,
            'aria-label': `${label}Alt`
          })
        ) : (
          icon
        )}
      </div>
      <div className="footer-label-distance">
        <span className={`footer-label ${className}`}>{label}</span>
      </div>
    </button>
  );
}

function OverlayFooter({ userInfo }) {
  const history = useHistory();
  const { id: paramsID } = useParams();
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'writeOffReleases',
      open: false,
      fullScreen: false,
      maxWidth: 'md',
      products: []
    },
    {
      id: 2,
      name: 'productTransference',
      open: false,
      fullScreen: false,
      maxWidth: 'lg'
    }
  ]);
  const [toastProps, setToastProps] = useState({});
  const [toastOpen, setToastOpen] = useState(false);
  const validProduction = history?.location?.pathname.includes('producao');
  const validCount = history?.location?.pathname.includes('contagens');
  const validReceive = history?.location?.pathname.includes('recebimento');
  const validDropCasualities = modalSettings?.find(
    (modal) => modal.name === 'writeOffReleases'
  ).open;
  const validTransfer = modalSettings?.find(
    (modal) => modal.name === 'productTransference'
  ).open;
  const isChinaWhiteLabel = userInfo?.whiteLabel === 'CHINA';

  return (
    <div
      className={`overlay-footer ${isChinaWhiteLabel && 'chinaOverlayFooter'}`}
    >
      <FooterButton
        className={validProduction ? 'bold footer-button-color-hover' : ''}
        icon={
          <ProductionSecondaryIcon
            variant={validProduction ? 'solid' : 'outline'}
            width={23}
            height={18}
            brandColor={isChinaWhiteLabel ? "#E32D2D" : "#5062F0"}
          />
        }
        label="Produzir"
        onClick={() => history.push(`/producao/${paramsID}`)}
      />
      <FooterButton
        className={validCount ? 'bold footer-button-color-hover' : ''}
        icon={
          <CountSecondaryIcon
            variant={validCount ? 'solid' : 'outline'}
            width={18}
            height={19}
            brandColor={isChinaWhiteLabel ? "#E32D2D" : "#5062F0"}
          />
        }
        label="Contar"
        onClick={() => history.push(`/inventario/contagens/${paramsID}`)}
      />
      <FooterButton
        className={validReceive ? 'bold footer-button-color-hover' : ''}
        icon={
          <ReceivementSecondaryIcon
            variant={validReceive ? 'solid' : 'outline'}
            width={18}
            height={19}
            brandColor={isChinaWhiteLabel ? "#E32D2D" : "#5062F0"}
          />
        }
        label="Receber"
        onClick={() => history.push(`/recebimento/${paramsID}`)}
      />
      <FooterButton
        className={validDropCasualities ? 'bold footer-button-color-hover' : ''}
        icon={
          <TrashSecondaryIcon
            variant={validDropCasualities ? 'solid' : 'outline'}
            width={18}
            height={19}
            brandColor={isChinaWhiteLabel ? "#E32D2D" : "#5062F0"}
          />
        }
        label="Lançar baixas"
        onClick={() =>
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'writeOffReleases'
                ? { ...modal, open: true }
                : modal
            )
          )
        }
      />
      <FooterButton
        className={validTransfer ? 'bold footer-button-color-hover' : ''}
        icon={
          <TransferSecondaryIcon
            variant={validTransfer ? 'solid' : 'outline'}
            width={18}
            height={19}
            brandColor={isChinaWhiteLabel ? "#E32D2D" : "#5062F0"}
          />
        }
        label="Transferir"
        onClick={() =>
          setModalSettings(
            modalSettings.map((modal) =>
              modal.name === 'productTransference'
                ? { ...modal, open: true }
                : modal
            )
          )
        }
      />

      {modalSettings?.find((modal) => modal.name === 'writeOffReleases')
        .open && (
        <Suspense fallback={<span />}>
          <WriteOffReleases
            open={
              modalSettings?.find((modal) => modal.name === 'writeOffReleases')
                .open
            }
            handleClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'writeOffReleases'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
          />
        </Suspense>
      )}

      {modalSettings?.find((modal) => modal.name === 'productTransference')
        .open && (
        <ProductTransference
          setToastOpen={setToastOpen}
          setToastProps={setToastProps}
          product={
            modalSettings.find((modal) => modal.name === 'productTransference')
              ?.product
          }
          userInfo={userInfo}
          modalSettings={modalSettings}
          setModalSettings={setModalSettings}
          noProduct
          onClose={() => {
            setModalSettings(
              modalSettings.map((modal) =>
                modal.name === 'productTransference'
                  ? { ...modal, open: false, product: null }
                  : modal
              )
            );
          }}
        />
      )}

      <CommonAlert
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        severity={toastProps.severity}
        indexMessage={toastProps.message}
        messagePersonal={toastProps.message}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OverlayFooter);
